import { LitElement, html, css, classMap } from '@hh/global.js'
class HHStickyAtc extends LitElement {
  static properties = {
    _state: {
      type: Number,
      state: true,
    },
    'form-id': { type: String },
  }

  constructor() {
    super()

    this._state = -1
  }

  connectedCallback() {
    super.connectedCallback()
    this.onScrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    this.createObserver()
    this.onScroll()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      observer.disconnect()
    })

    observer.observe(document.documentElement)
  }

  onScroll() {
    const { bottom } = this.getBoundingClientRect()

    if (bottom <= 0) {
      requestAnimationFrame(this.hide.bind(this))
    } else {
      requestAnimationFrame(this.reset.bind(this))
    }
  }

  hide() {
    if (this._state === 1) {
      return
    }
    this._state = 1
    this.classList.add('scrolled')
  }

  reset() {
    if (this._state === -1) {
      return
    }
    this._state = -1
    this.classList.remove('scrolled')
  }

  onAdd(event) {
    if (event.target.getAttribute('data-notify') === 'true') {
      const backInStock = document.querySelector('hh-back-in-stock')
      backInStock.querySelector('button').click()
      backInStock.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
      return
    }

    if (event.target.classList.contains('js-product-select-option')) {
      const sizeSelector = document.querySelector('hh-variant-picker')
      sizeSelector.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
      return
    }

    document
      .querySelector(`#${this['form-id']}`)
      .querySelector('[name="add"]')
      .click()
  }

  render() {
    return html`<div
        class="container ${classMap({ 'fixed': this._state === 1 })}"
      >
        <div class="inner">
          <slot @click="${this.onAdd.bind(this)}"></slot>
        </div>
      </div>`
  }

  static styles = css`
    @media (max-width: 990px) {
      .container {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        transform: translateY(100%);
        background-color: var(--hh-color-reverse, #F7F7F7);
        border-top: var(--hh-border-width, 0.1rem) solid var(--hh-border-color, #b8b8b8);
        z-index: var(--hh-z-index, 100);
        transition: all var(--hh-duration-long, 500ms);
      }

      .container.fixed {
        transform: translateY(0);
      }

      .container .inner {
        padding: var(--hh-sticky-padding, 1.5rem 2rem);
      }
    }
  `
}

customElements.define('hh-sticky-atc', HHStickyAtc)
